import Clock from 'components/atoms/Clock/Clock';
import MediaSwitch from 'components/molecules/MediaSwitch/MediaSwitch';
import StudentLessonChatSwitch from 'components/molecules/StudentLessonChatSwitch/StudentLessonChatSwitch';
import { HostMediaContext } from 'contexts/hostMediaContext';
import { Button } from 'primereact/button';
import { PropsWithChildren, useContext } from 'react';
import styles from './StudentLessonFooter.module.scss';
import { useTranslation } from 'react-i18next';

interface ComponentProps {
  conversationId: string | null;
  toggleChat: () => void;
  endCallback: () => void;
}

const StudentLessonFooter = ({ conversationId, toggleChat, endCallback }: PropsWithChildren<ComponentProps>) => {
  const { camera, startCamera, stopCamera, microphone, startMicrophone, stopMicrophone, display, startDisplay, stopDisplay } = useContext(HostMediaContext);
  const { t } = useTranslation();

  return (
    <footer className={styles.wrapper}>
      <aside className="h-10 sm:h-5 flex flex-row">
        <div>
          <Clock/>
        </div>
      </aside>
      <nav>
        <MediaSwitch type="camera"
                     isEnabled={!!camera}
                     enable={startCamera}
                     disable={stopCamera}
        />
        <MediaSwitch type="microphone"
                     isEnabled={!!microphone}
                     enable={startMicrophone}
                     disable={stopMicrophone}
        />
        <MediaSwitch type="share"
                     isEnabled={!!display}
                     enable={startDisplay}
                     disable={stopDisplay}
                     enabledColor="danger"
                     disabledColor="primary"
        />
        <Button className="p-button-rounded p-button-danger" onClick={endCallback} tooltip={t('Leave lesson')} tooltipOptions={{ position: 'top' }}>
          <span className="material-icons">call_end</span>
        </Button>
      </nav>
      <StudentLessonChatSwitch toggleChat={toggleChat} conversationId={conversationId}/>
    </footer>
  );
};

export default StudentLessonFooter;